// Utils/LeadContext.js
import React, { createContext, useContext, useState } from 'react';

const LeadContext = createContext();

export const LeadProvider = ({ children }) => {
  const [leadData, setLeadData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  return (
    <LeadContext.Provider value={{ leadData, setLeadData, loading, setLoading, error, setError }}>
      {children}
    </LeadContext.Provider>
  );
};

export const useLeadData = () => {
  const context = useContext(LeadContext);
  if (!context) {
    throw new Error('useLeadData must be used within LeadProvider');
  }
  return context;
};